
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick } from 'vue'
import { ToTopOutlined, RightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import { useStore, mapState, mapMutations, mapActions } from 'vuex'
import Modal from '@/views/f10/modal.vue'
// import Navatop from '../../components/navtop.vue'
import Navatop from '../../components/navtopF10.vue'

// import Navatop from "@/components/navatop.vue";
import api from '@/api/allApi'
import gsgy from '@/components/pageHk/gsgy.vue'
import zxzb from '@/components/pageHk/zxzb.vue'
import jqzysj from '@/components/pageHk/jqzysj.vue'
import dshcy from '@/components/pageHk/dshcy.vue'
import gdfx from '@/components/pageHk/gdfx.vue'
import lhbd from '@/components/pageHk/lhbd.vue'
import lhbdDetail from '@/components/pageHk/lhbdDetail.vue'
import dzjy from '@/components/pageHk/dzjy.vue'
import rzrq from '@/components/pageHk/rzrq.vue'
import xxqk from '@/components/pageHk/xxqk.vue'
import fxxg from '@/components/pageHk/fxxg.vue'
import gdrs from '@/components/pageHk/gdrs.vue'
import sdltgd from '@/components/pageHk/sdltgd.vue'
import sdgd from '@/components/pageHk/sdgd.vue'
import jgcc from '@/components/pageHk/jgcc.vue'
import sdgdcgbd from '@/components/pageHk/sdgdcgbd.vue'
import sdgdcgbdDetail from '@/components/pageHk/sdgdcgbdDetail.vue'
import jjcg from '@/components/pageHk/jjcg.vue'
import xsjj from '@/components/pageHk/xsjj.vue'
import xsjjDetail from '@/components/pageHk/xsjjDetail.vue'
import zyjs from '@/components/pageHk/zyjs.vue'
import zygcfx from '@/components/pageHk/zygcfx.vue'
import jyps from '@/components/pageHk/jyps.vue'
import gbjg from '@/components/pageHk/gbjg.vue'
import lngbbd from '@/components/pageHk/lngbbd.vue'
import yjyc from '@/components/pageHk/yjyc.vue'
import ycmx from '@/components/pageHk/ycmx.vue'
import xxzbyc from '@/components/pageHk/xxzbyc.vue'
import ybpj from '@/components/pageHk/ybpj.vue'
import gglb from '@/components/pageHk/gglb.vue'
import ggjxgrycgbd from '@/components/pageHk/ggjxgrycgbd.vue'
import ggjxgrycgbdDetail from '@/components/pageHk/ggjxgrycgbdDetail.vue'
import zyzb from '@/components/pageHk/zyzb.vue'
import dbfx from '@/components/pageHk/dbfx.vue'
import zcfzb from '@/components/pageHk/zcfzb.vue'
import lrb from '@/components/pageHk/lrb.vue'
import xjllb from '@/components/pageHk/xjllb.vue'
import bfbbb from '@/components/pageHk/bfbbb.vue'
import fhqk from '@/components/pageHk/fhqk.vue'
import lnfhrz from '@/components/pageHk/lnfhrz.vue'
import zfmx from '@/components/pageHk/zfmx.vue'
import jqzysjDetail from '@/components/pageHk/jqzysjDetail.vue'
import zdsx from '@/components/pageHk/zdsx.vue'
import dzjyDetail from '@/components/pageHk/dzjyDetail.vue'
import rzrqDetail from '@/components/pageHk/rzrqDetail.vue'
import hydw from '@/components/pageHk/hydw.vue'
import hykd from '@/components/pageHk/hykd.vue'
import pgmx from '@/components/pageHk/pgmx.vue'
import dyhd from '@/components/pageHk/dyhd.vue'
import gszx from '@/components/pageHk/gszx.vue'
import cwbg from '@/components/pageHk/cwbg.vue'
import gsggDetail from '@/components/pageHk/gsggDetail.vue'
import yjbg from '@/components/pageHk/yjbg.vue'
import tzzhd from '@/components/pageHk/tzzhd.vue'
import HydwHeadline from '@/components/HydwHeadline.vue'
import globalsets from '@/utils/globalsets'
import glccy from '@/components/pageHk/glccy.vue'
import zygd from '@/components/pageHk/zygd.vue'
import gbbd from '@/components/pageHk/gbbd.vue'
import zjzl from '@/components/pageHk/zjzl.vue'
import fchb from '@/components/pageHk/fchb.vue'
import fhtj from '@/components/pageHk/fhtj.vue'
import gsgg from '@/components/pageHk/gsgg.vue'
import ssetf from '@/components/pageHk/ssetf.vue'
import pesylttm from '@/components/pageHk/pesylttm.vue'
import pbsyllf from '@/components/pageHk/pbsyllf.vue'
import pssylttm from '@/components/pageHk/pssylttm.vue'
import cwzb from '@/components/pageHk/cwzb.vue'
import fhpx from '@/components/pageHk/fhpx.vue'
import gphg from '@/components/pageHk/gphg.vue'
import gxxg from '@/components/pageHk/gxxg.vue'
import cwzbnewZui from '@/components/pageHk/cwzbnewZui.vue'

export default defineComponent({
  components: {
    ToTopOutlined,
    RightOutlined,
    glccy,
    fhpx,
    gxxg,
    gphg,
    cwzb,
    cwzbnewZui,
    ssetf,
    pbsyllf,
    pssylttm,
    pesylttm,
    fhtj,
    gsgg,
    fchb,
    zjzl,
    zygd,
    gbbd,
    Navatop,
    cwbg,
    gsgy,
    zxzb,
    jqzysj,
    dshcy,
    gdfx,
    lhbd,
    lhbdDetail,
    dzjy,
    rzrq,
    xxqk,
    fxxg,
    gdrs,
    sdltgd,
    sdgd,
    jgcc,
    sdgdcgbd,
    sdgdcgbdDetail,
    jjcg,
    xsjj,
    xsjjDetail,
    zyjs,
    zygcfx,
    jyps,
    gbjg,
    lngbbd,
    yjyc,
    ycmx,
    xxzbyc,
    ybpj,
    gglb,
    ggjxgrycgbd,
    ggjxgrycgbdDetail,
    zyzb,
    dbfx,
    zcfzb,
    lrb,
    xjllb,
    bfbbb,
    fhqk,
    lnfhrz,
    zfmx,
    jqzysjDetail,
    zdsx,
    hydw,
    hykd,
    pgmx,
    dyhd,
    gszx,
    gsggDetail,
    yjbg,
    tzzhd,
    HydwHeadline,
    dzjyDetail,
    rzrqDetail,
    Modal // 模态框
  },
  setup(props, context) {
    const pageData: any = reactive({
      nav: [],
      cardtitleimg: require('@/assets/cardtitle_l.png'),
      key: '' + new Date().getTime(),
      target: () => document.querySelector('.wrapper'),
      isopen: true,
      theme: 'light',
      token: '',
      pageSourceData: {},
      currentsharesData: {},
      activekey: '',
      showbacktop: true,
      containerRef: () => document.querySelector('.wrapper'),
      spinning: true,
      pubDate: '', // 报告期
      modalsrc: ''
    })
    const route = useRoute()
    const store = useStore()
    const navatop: any = ref('')

    const modalvisible = ref<boolean>(false)
    const closemodal = () => {
      modalvisible.value = false
    }
    if (route.query.theme === 'dark') {
      pageData.theme = 'dark'
      pageData.cardtitleimg = require('@/assets/cardtitle_d.png')
    } else {
      pageData.theme = 'light'
      pageData.cardtitleimg = require('@/assets/cardtitle_l.png')
    }
    function getPubDate(val: any) {
      pageData.pubDate = val
    }
    function setnav(data: any) {
      nextTick(() => {
        const dom: any = document.querySelector('.wrapper')
        if (dom) {
          dom.scrollTop = 0
        }
      })
      pageData.spinning = true
      pageData.nav = data
      pageData.key = '' + new Date().getTime()
    }
    function setisopen(data: any) {
      pageData.isopen = data
    }

    // 测试
    // const obj = {
    //   OrgCode: "tc",
    //   Token: "22af8018-1e5e-4196-805c-c49e85bae26d",
    //   AppName: "tctest",
    //   AppVer: "V3.1.9",
    //   AppType: "ios",
    //   Tag: "mytag123456"
    // };
    async function gettoken() {

      // f10Hk 
      // if (route.query.token) {
      pageData.token = route.query.token
      console.log('pageData.token', route.query.token)
      // }


      // pageData.token = await globalsets.getToken()
    }
    function getPageData(data: any) {
      console.log('getPageData', data)
      pageData.spinning = false
      pageData.pageSourceData = data
      pageData.pageSourceData.nameStr = data?.Fin?.P10?.FormerName?.length ? data?.Fin?.P10?.FormerName.join('->') : null
    }
    function currentshares(data: any) {
      pageData.currentsharesData = data
    }
    function seemore(item: any) {
      const data: any = {}
      data.key = item.target.split(',')[0]
      data.itemkey = item.target.split(',')[1]
      navatop.value.setcurrentli(data)
    }
    function seemoreDetail(item: any) {
      // const data: any = {}
      const softNameAbbr = route.query.softNameAbbr
      const path = softNameAbbr === 'jfztADV' ? 'jfzt_adv' : 'jfzt_qjb'
      if (item.key === 'jjcg') {
        let host = ''
        if (document.location.origin.indexOf('http://localhost') > -1) {
          host = 'https://test-pcstatic.9fh5.com'
        } else {
          // 如果是非PC域名，暂定https://pcstatic.sylapp.cn
          host = document.location.origin.indexOf('pcstatic') > -1 ? document.location.origin : 'https://pcstatic.sylapp.cn'
        }
        // 官网用H5弹框打开
        if (softNameAbbr === 'jfztGW') {
          const url = `${host}/${path}/eframe/index.html#/stockPopup?Inst=${route.query.code}&Exch=${route.query.market}&Name=${pageData.currentsharesData.name}&PubDate=${pageData.pubDate}&softNameAbbr=jfztGW`
          store.commit('setIframeModalInfo', {
            modalsrc: url,
            modalvisible: true,
            title: '个股主力持仓',
            width: '948px'
          })
        } else {
          window.open(
            `gw://webkitdlg?width=900;height=620;mode=0;title=个股主力持仓;allowdestroy=1;FixTab=1;url=${host}/${path}/eframe/index.html#/stockPopup?Inst=${route.query.code}&Exch=${route.query.market}&Name=${pageData.currentsharesData.name}&PubDate=${pageData.pubDate}`
          )
        }
        return
      }
      let param = ''
      let param0: any = null
      let param1: any = null
      switch (item.key) {
        case 'lhbd':
          param = '个股龙虎榜详情'
          break
        case 'lhbdDetail':
          param = '个股龙虎榜详情'
          break
        case 'dzjy':
          param = '个股大宗交易'
          break
        case 'dzjyDetail':
          param = '个股大宗交易'
          break
        case 'rzrq':
          param = '融资融券个股详情'
          break
        case 'rzrqDetail':
          param = '融资融券个股详情'
          break
        case 'tzzhd':
          param = '问董秘'
          break
        case 'ggjxgrycgbd':
          param = '个股高管增持'
          param0 = route.query.market
          param1 = route.query.code
          break
        case 'ggjxgrycgbdDetail':
          param = '个股高管增持'
          param0 = route.query.market
          param1 = route.query.code
          break
      }
      if (item.key === 'tzzhd') {
        const url = `gw://funccall?funcname=OnFireCommand;Command=CmdStyle.WDM;param=<params><web_inner_url>${origin}/operationmanual/index.html#/asking?market=${route.query.market}&code=${route.query.code}</web_inner_url><stock_list><list_code>问董秘</list_code></stock_list></params>`
        window.open(url)
      } else {
        let url = `gw://funccall?funcname=OnDoCommand;param=${param}`
        if (param0) {
          url += param0 ? `;param0=${param0}` : ''
        }
        if (param1) {
          url += param1 ? `;param1=${param1}` : ''
        }
        window.open(url)
      }
    }

    let scrollTop = 0
    const scrollEndTop = 0
    let timer: any = null
    function scrollhashwrapper(event: any) {
      pageData.showbacktop = true
      clearTimeout(timer)
      timer = setTimeout(showtop, 3000)
      scrollTop = event.target.scrollTop
    }
    function showtop() {
      pageData.showbacktop = false
    }
    gettoken()
    return {
      ...toRefs(pageData),
      setnav,
      setisopen,
      gettoken,
      getPageData,
      seemore,
      navatop,
      seemoreDetail,
      scrollhashwrapper,
      currentshares,
      getPubDate,
      modalvisible,
      closemodal
    }
  }
})
